module.exports = __webpack_public_path__ + "static/twilio-b3c9bed9b9859b88d3dbb2e29223aa11.png";